// variable to switch between testnet and polygon
var isMainnetProduction = true;
/**
* @file overview This file contains the contract addresses and ABI's
*/

/**
* @constant {object} CONTRACTS - The contract addresses
*/
export const CONTRACTS = {
    // Token RACE
    TOKEN: isMainnetProduction ? "0xdc66010a5558473Fb91b21666B56E4D13Fd7254A" : '0xd020b1566d4E351D0cF6F3f8111602F337C94dD2',

    // Token USDT
    USDT: isMainnetProduction ? '0x05d032ac25d322df992303dca074ee7392c117b9' : '0x5d3E04cC39617e2D7D00b6Df6b716bEf3DF9A27d',

    // Token USDC
    USDC: isMainnetProduction ? '0xb62f35b9546a908d11c5803ecbba735abc3e3eae' : '0x5d3E04cC39617e2D7D00b6Df6b716bEf3DF9A27d',

    // Token USDC
    DAI: isMainnetProduction ? '0x6c851f501a3f24e29a8e39a29591cddf09369080' : '0x844347e195d524A8aAe59cC96Ff5bd3b378d6E06',

    // NFT
    NFT_ADDRESS: isMainnetProduction ? '0x93779819c6CaC7Cc625B619B614F639433c9C615' : "0xE10829E111c0eB2d303b3849E298b72ae4D7499D",

    // Staking
    STAKE_CONTRACT: isMainnetProduction ? "0x2b66610961111bee3ad2417787AA95DCb5EF6C59" : "0xcbcc89dC8F0C6dD0374E9B52b655C0D9dba8D07D",

    // Admin, User Management and DIC Management (Only used at admin side)
    USER_MANAGE: isMainnetProduction ? "0xCf6A32dB8b3313b3d439CE6909511c2c3415fa32" : '0xD571eBD17956d66268FaAc2337d134e6e693deD6',
    DIC_MANAGE: isMainnetProduction ? "0xf54B2BAEF894cfF5511A5722Acaac0409F2F2d89" : '0x245e03700d8bf7A0d1Aa619fb633213d4f516E18',
    ADMIN: isMainnetProduction ? "0x0f33D824d74180598311b3025095727BeA61f219" : '0x00ad120EDcF0f16a61a1D8dcAF568262b8E0050d',

    // Create Project, Complete Review, Complete Vote, Suggestion term and Approve Suggestions
    CREATE_PROPOSAL: isMainnetProduction ? "0x17d13c7Fb85795825dF97BE3cF4eE0317911e309" : '0x81044C038d705f796b378c69cB5Fe186AA682A2a',
    DIC_PROPOSAL: isMainnetProduction ? "0xFA440a952EAc1bfabb38272f8cD88ABE6C0985eE" : '0x745De5Ea9c88e6Ba0B6f5f786856cF6fcB8D9BEB',

    // Watch, GOLD, ASSET
    WATCH_MARKETPLACE: isMainnetProduction ? '0xC5e2063FBb77977a50703fCFFb54f06B4645e6cf' : "0x976f04A5377DCb419F300A70Fa931eF021a710AF",
    WATCH_DEBT_OFFER_ADDRESS: isMainnetProduction ? '0xBFE15ae2D2a468c320d0075B79d7Bf1e5f9163BE' : "0x5ac760C8aaDf66989F67C4d60B6fe3041B0C7CCb",
    WATCH_REPAYMENT_ADDRESS: isMainnetProduction ? '0x36eF8d1C6b536C08095ABaAE8a4D3EFCD3653825' : "0x4743755d8A8A800892c9e3c2fde70c3c523DCb85",

    // Art - Sale
    ART_SALE_MARKETPLACE: isMainnetProduction ? '0xc7EA8159782b4B8E57d36c762986340b0eB86E0b' : "0x0B1CEA004eAF501720d633BB39C3eCa8F1E1A84F",

    // Art - Parcel
    ART_PARCEL: isMainnetProduction ? '0x3c5c33eC6EcdA66a174761a7085f0210AbF31d5F' : "0x38dA3b26305Ae2c825A26Cc7f3c1F7793805B593",

    // SPV
    SPV_MARKETPLACE: isMainnetProduction ? '0xa81Ec35dF8DB8AebcB56228803Fa278dd7d7155F' : "0x5Bf089E395AF5fA736D41fCC832fbc156317d547",
    SPV_DEBT_OFFER_ADDRESS: isMainnetProduction ? '0x4C40EeC05dD43078E7419f21537dA3C9A0BE0CDD' : "0x62162477419D2588817E3C3740296181C16BAa25",
    SPV_DEBT_REPAYMENT_ADDRESS: isMainnetProduction ? '0x004905e36FC9E194a14493F5AE183f867fe19da0' : "0x246C2a997C325A80BF2271302508D1C38098524d",
    SPV_EQUITY_OFFER_ADDRESS: isMainnetProduction ? '0xa66012bDb82585C5697DCff9EFde5662116A2bf1' : "0x6589bd308590a75cb617438cF0227eC6C2928B4D",
    SPV_EQUITY_REPAYMENT_ADDRESS: isMainnetProduction ? '0x66F51B60b8bF6A11B9F27266ac2a35131E61D5Ae' : "0x877Ab506A83fE65779d24481c8e07Ed15BDCcD47",

    // Funds
    FUNDS_MARKETPLACE: isMainnetProduction ? '0x81C0a590450a64409e6651eb13A0fC7ec8FD4B89' : '0x8A1538E8367De77d2A5F9dfffE6E0206B692b2CB',
    FUNDS_EQUITY_OFFER: isMainnetProduction ? '0xA08ce7651404d48ad068ba057E1bFD97Bb96163E' : '0x8e08111A7763C60C838Dd5abD0C159a3A4DB9a59',
    FUNDS_EQUITY_REPAYMENT: isMainnetProduction ? '0xB8e7d039706bd5415d0509e0e6E40A0F3C655643' : '0xbEe4f21478eEb8Bbd0d03098f41ffA7cf3814c57',

    // Helper module and calculate emi
    HELPER_MODULE: isMainnetProduction ? '0xB9b8858eD6898e68b55cC1E9766674C9D9802675' : "0x79FDde81e0aA0ac24D191bf6B8477759542da652",
    CALCULATE_EMI: isMainnetProduction ? '0xACC3FA34498373eaE9Dc92409D2C67E04F876619' : "0x401d832AeA2f946F7AFDd5b2A1Fc06812CB9e954",
}


/**
 * @constant {object} CONTRACT_ABI - The contract ABI's
 */
export const CONTRACT_ABI = {
    [CONTRACTS.TOKEN]: isMainnetProduction ? require("./abi/TokenRT.json") : require("./abi/Token.json"),
    [CONTRACTS.USDT]: isMainnetProduction ? require("./abi/TokenUSDTRT.json") : require("./abi/TokenUSDT.json"),
    [CONTRACTS.USDC]: isMainnetProduction ? require("./abi/TokenUSDCRT.json") : require("./abi/TokenUSDC.json"),
    [CONTRACTS.DAI]: isMainnetProduction ? require("./abi/TokenDIART.json") : require("./abi/TokenDIA.json"),
    [CONTRACTS.NFT_ADDRESS]: isMainnetProduction ? require("./abi/NFTRT.json") : require("./abi/NFT.json"),
    [CONTRACTS.USER_MANAGE]: isMainnetProduction ? require("./abi/UserRT.json") : require("./abi/User.json"),
    [CONTRACTS.DIC_MANAGE]: isMainnetProduction ? require("./abi/DicManageRT.json") : require("./abi/DicManage.json"),
    [CONTRACTS.ADMIN]: isMainnetProduction ? require("./abi/AdminRT.json") : require("./abi/Admin.json"),
    [CONTRACTS.STAKE_CONTRACT]: isMainnetProduction ? require("./abi/StakeContractRT.json") : require("./abi/StakeContract.json"),
    [CONTRACTS.DIC_PROPOSAL]: isMainnetProduction ? require("./abi/DicProposalRT.json") : require("./abi/DicProposal.json"),
    [CONTRACTS.CREATE_PROPOSAL]: isMainnetProduction ? require("./abi/CreateProposalRT.json") : require("./abi/CreateProposal.json"),
    [CONTRACTS.WATCH_MARKETPLACE]: isMainnetProduction ? require("./abi/WatchMarketplaceRT.json") : require("./abi/WatchMarketplace.json"),
    [CONTRACTS.WATCH_DEBT_OFFER_ADDRESS]: isMainnetProduction ? require("./abi/WatchLoanOfferRT.json") : require("./abi/WatchLoanOffer.json"),
    [CONTRACTS.WATCH_REPAYMENT_ADDRESS]: isMainnetProduction ? require("./abi/WatchLoanRepaymentRT.json") : require("./abi/WatchLoanRepayment.json"),
    [CONTRACTS.ART_SALE_MARKETPLACE]: isMainnetProduction ? require("./abi/ArtSaleMarketplaceRT.json") : require("./abi/ArtSaleMarketplace.json"),
    [CONTRACTS.ART_PARCEL]: isMainnetProduction ? require("./abi/ArtParcelRT.json") : require("./abi/ArtParcel.json"),
    [CONTRACTS.SPV_MARKETPLACE]: isMainnetProduction ? require("./abi/SPVMarketplaceRT.json") : require("./abi/SPVMarketplace.json"),
    [CONTRACTS.SPV_DEBT_OFFER_ADDRESS]: isMainnetProduction ? require("./abi/SPVDebtOfferRT.json") : require("./abi/SPVDebtOffer.json"),
    [CONTRACTS.SPV_DEBT_REPAYMENT_ADDRESS]: isMainnetProduction ? require("./abi/SPVDebtRepaymentRT.json") : require("./abi/SPVDebtRepayment.json"),
    [CONTRACTS.SPV_EQUITY_OFFER_ADDRESS]: isMainnetProduction ? require("./abi/SPVEquityInvestmentRT.json") : require("./abi/SPVEquityInvestment.json"),
    [CONTRACTS.SPV_EQUITY_REPAYMENT_ADDRESS]: isMainnetProduction ? require("./abi/SPVEquityRepaymentRT.json") : require("./abi/SPVEquityRepayment.json"),
    [CONTRACTS.FUNDS_MARKETPLACE]: isMainnetProduction ? require("./abi/FundsMarketplaceRT.json") : require("./abi/FundsMarketplace.json"),
    [CONTRACTS.FUNDS_EQUITY_OFFER]: isMainnetProduction ? require("./abi/FundsOfferRT.json") : require("./abi/FundsOffer.json"),
    [CONTRACTS.FUNDS_EQUITY_REPAYMENT]: isMainnetProduction ? require("./abi/FundsRepaymentRT.json") : require("./abi/FundsRepayment.json"),
    [CONTRACTS.HELPER_MODULE]: isMainnetProduction ? require("./abi/HelperModuleRT.json") : require("./abi/HelperModule.json"),
    [CONTRACTS.CALCULATE_EMI]: isMainnetProduction ? require("./abi/CalculateEMIRT.json") : require("./abi/CalculateEMI.json"),
}